import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import { DialogTitle, Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { web_url } from "../../constant";
import axios from "axios";

const url = "http://localhost:8080/api/";
function StudentDashboardPageMobile() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [personDetails, setPersonDetails] = useState({
        userName: "",
        mobile: "",
        school: "",
        district: "",
        grade: "",
        class: "",
        email: "",
        personal_interest: {},
    })
    const [imageSrc, setImageSrc] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
        } else {
            setErrorMsg(t('t94'));
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };

    useEffect(() => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) ||
                JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const logDetails = getLogDetails();
        if (!logDetails?.email) {
            // console.log("No user details found");
            setIsLoading(false);
            return;
        }

        const fetchStudentDetails = async () => {
            try {
                // Fetch student details
                const getLogDetails2 = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails2 = getLogDetails2();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails2.token}`,
                    },
                };
                const apiUrl = `${web_url}/api/auth/students/${logDetails.email}`;
                axios.get(apiUrl, configToken).then((response) => {
                    const [grade, section] = response.data.assignedClass.split("-");
                    setPersonDetails({
                        userName: response.data.userFullName,
                        mobile: response.data.contactNumber,
                        school: response.data.school,
                        district: response.data.district,
                        grade,
                        class: section,
                        email: response.data.userEmail,
                        personal_interest: response.data.personalInterests || {},
                    });
                    localStorage.setItem('email', response.data.userEmail);
                    localStorage.setItem('school', response.data.school);
                    localStorage.setItem('teacherName', response.data.teacherName);
                    localStorage.setItem('assignedClass', response.data.assignedClass);
                    localStorage.setItem('penpalEmail', response.data.penpalEmail || "empty");
                    localStorage.setItem('preferredLang', response.data.preferredLanguage);
                    setLanguage(response.data.preferredLanguage);
                    // Fetch profile photo

                    const teacherD = {
                        school: response.data.school,
                        assignedClass: response.data.assignedClass,
                        district: response.data.district
                    }

                    const config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${logDetails.token}`
                        },
                    };

                    axios.post(`${web_url}/api/auth/teachers/filter`, teacherD, config).then((responseNew) => {

                        const teacherEmail = (responseNew.data)[0].userEmail;
                        localStorage.setItem('teacherEmail', teacherEmail)
                        // console.log('t mail',teacherEmail);
                        const getLogDetails2 = () => {
                            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                        };
                        const logDetails2 = getLogDetails2();

                        const configToken = {
                            headers: {
                                'Authorization': `Bearer ${logDetails2.token}`,
                            },
                        };
                        
                        axios.get(`${web_url}/api/email-threads/participants/${logDetails.email}`, configToken).then((response) => {
                            let allMessages = response.data.flatMap(thread =>
                                thread.messages.map(message => ({
                                    ...message,
                                    threadId: thread.threadId,
                                    subject: thread.subject || " ",
                                    initialSender: thread.messages[0].sender,
                                    translatedSubject: thread.translatedSubject || " ",
                                    sentAt: formatDate(message.sentAt),
                                    sentAtOriginal: formatDateNew(message.sentAt),
                                    other: thread.participants.find(email => email !== message.sender) || null,
                                    isRead: thread.participantsStatus
                                        ? thread.participantsStatus.find(person => person.email === logDetails.email)?.isRead ?? true
                                        : true
                                }))
                            );
                            console.log("All messages:", allMessages);

                            const today = new Date();
                            const currentDay = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6

                            // Calculate Monday (start of the week)
                            const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay;
                            const weekStart = new Date(today);
                            weekStart.setDate(today.getDate() + diffToMonday);
                            weekStart.setHours(0, 0, 0, 0);

                            // Calculate Sunday (end of the week)
                            const weekEnd = new Date(weekStart);
                            weekEnd.setDate(weekStart.getDate() + 6);
                            weekEnd.setHours(23, 59, 59, 999);

                            // Filter messages from this week (sent or received)
                            const sentMessagesPerWeek = allMessages.filter(msg => {
                                const sentDate = new Date(msg.sentAtOriginal); // always use ISO format
                                return (
                                    msg.type === "PENPAL" &&
                                    msg.isDraft === "FALSE" &&
                                    (msg.sender === logDetails.email) &&
                                    sentDate >= weekStart &&
                                    sentDate <= weekEnd
                                );
                            });
                            // console.log("Sent messages per week:", sentMessagesPerWeek);
                            localStorage.setItem('sentMessagesPerWeek', sentMessagesPerWeek.length.toString());
                            setIsLoading(false);


                        }).catch((err) => {
                            handleClickOpenError("error occured");
                            setIsLoading(false);

                        })


                    }).catch((error) => {
                        // console.error("Error fetching teacher email", error);
                        handleClickOpenError("error occured");
                        setIsLoading(false);
                    })
                }).catch((error) => {
                    setErrorMsg("Error occured");
                    setIsLoading(false);
                })

            } catch (error) {
                console.log("Error occured")
                setIsLoading(false);
                // console.error("Error occurred while fetching data", error);
            }
        };

        fetchStudentDetails();

        return () => {
            if (imageSrc) {
                URL.revokeObjectURL(imageSrc);
            }
        };
    }, []);


    const formatDateNew = (timestamp) => {
        return new Date(timestamp).toISOString(); // Ensures cross-browser compatibility
    };

    const formatDate = (timestamp) => {
        const dateObj = new Date(timestamp);

        // Convert to IST (UTC + 5:30)
        // const istOffset = 0;
        const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
        const istTime = new Date(dateObj.getTime() + istOffset);

        // Use .getFullYear(), .getMonth(), etc., instead of .getUTC*
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
        const day = String(istTime.getDate()).padStart(2, "0"); // Ensure 2 digits
        const hours = String(istTime.getHours()).padStart(2, "0"); // Corrected
        const minutes = String(istTime.getMinutes()).padStart(2, "0"); // Corrected
        const sec = String(istTime.getSeconds()).padStart(2, "0"); // Corrected

        // console.log("old", timestamp);
        // console.log("new", `${year}-${month}-${day} ${hours}:${minutes}:${sec}`);

        return `${year}-${month}-${day} ${hours}:${minutes}:${sec}`;
    }

    const [openLang, setOpenLang] = useState(false);
    const handleCloseLang = () => {
        setOpenLang(false);
    };

    // const changeLanguageButtonClick = (lang, langAbbr) => {
    //     setOpenLang(true);
    //     const getLogDetails = () => {
    //         return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    //     };
    //     const logDetails = getLogDetails();

    //     const languageChange = {
    //         preferredLanguage: lang
    //     }
    //     const config = {
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //     };
    //     axios.patch(`${web_url}/api/auth/students/${logDetails.email}`, languageChange, config).then((res) => {
    //         setLanguage(lang);
    //         setOpenLang(false);
    //         changeLanguage(langAbbr);
    //     }).catch((err) => {
    //         alert('Error occured. Cannot change language now.')
    //         setOpenLang(false);
    //     })
    // }

    useEffect(() => {
        const handleResize = () => {
            // console.log("happens");
            if (window.innerWidth >= 1270) {
                // console.log("happens");

                navigate('/desktop/student/dashboard')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "student") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <div>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
                <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                    <div className="flex justify-center items-center" >
                        <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                        <p className="ml-[10px] mr-[100px]  font-semibold text-[15px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                    </div>
                </div>
                <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                    <div>
                        <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                            {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                            <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                        </MenuButton>
                    </div>

                    {
                        !isLoading &&
                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en');
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si');
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta');
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    }
                </Menu>

                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[100px] md:pt-[200px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="xl:hidden flex flex-col items-center pt-[110px] md:pt-[200px] lg:pt-[250px] pb-[120px] md:pb-[200px]">
                                <div className="flex flex-col pt-[20px] justify-center items-center">
                                    <img className="h-[150px] w-[150px] rounded-full object-contain" src="/images/student_home.svg" alt="profile" />
                                    <div className="flex flex-col items-center  mt-[10px] px-[5px] py-[10px] ">
                                        <p className={`mt-[10px] font-bold ${i18n.language === "en" ? "text-[25px] md:text-[32px] lg:text-[40px] xl:text-[30px] 2xl:text-[41px]" : (i18n.language === "si" ? "text-[20px] md:text-[28px] lg:text-[38px] xl:text-[27px] 2xl:text-[37px]" : "text-[16px] md:text-[17px] lg:text-[25px] xl:text-[22px] 2xl:text-[27px]")} text-black`}>{t('t79')} {personDetails.userName}</p>
                                        {/* <p className="font-normal text-[15px] md:text-[25px] lg:text-[30px] text-black text-center">{t('t80')}</p> */}
                                        <p className="font-normal text-[15px] md:text-[25px] lg:text-[30px] pt-[20px] hyphens-auto break-words w-[90%] mx-auto ">
                                            {t('t81')}<br /><br />💌 {t('t82')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                }
            </div>
            <div className="xl:hidden grid grid-cols-4 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" onClick={() => (navigate('/mobile/student/mailbox'))} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" onClick={() => (navigate('/mobile/student/profile'))} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/message.svg" onClick={() => (navigate('/mobile/student/penpal/profile'))} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" onClick={() => (navigate('/mobile/student/settings'))} /></div>
            </div>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openLang}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseLang(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>
        </div>
    )
}

export default StudentDashboardPageMobile;